<template>
    <v-card>
        <v-sheet dark
                 color="#0CBBD6"
                 class="mx-auto pa-2"
                 elevation="8"
                 max-width="calc(100% - 16px)"
        >
            <v-row align="end" class="lightbox pa-2 fill-height">
                <v-col>
                    <div class="subheading text-start">
                        {{name}}
                    </div>
                    <div class="body-1 text-start">
                        {{email}}
                    </div>
                    <div class="body-1 text-start">
                        {{phone}}
                    </div>
                </v-col>
            </v-row>
        </v-sheet>

        <v-list dense>
            <v-subheader>
                <v-icon color="indigo"
                        left>
                    mdi-information
                </v-icon>
                System
            </v-subheader>
            <v-list-item two-line @click="">
                <v-list-item-content>
                    <v-list-item-title>Type</v-list-item-title>
                    <v-list-item-subtitle>{{ !!!type ? 'Unassigned' : type }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>
                    <v-list-item-title>Status</v-list-item-title>
                    <v-list-item-subtitle> {{ status ? 'Active' : 'Inactive' }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>
                    <v-list-item-title>{{userType}}</v-list-item-title>
                    <v-list-item-subtitle>{{ userNumber === undefined ? 0 : userNumber}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>
            <v-subheader>
                <v-icon color="indigo"
                        left>
                    mdi-account
                </v-icon>
                Account
            </v-subheader>
            <v-list-item two-line @click="">
                <v-list-item-content v-if="!guardianName">
                    <v-list-item-title>Username</v-list-item-title>
                    <v-list-item-subtitle>{{ username }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content v-else>
                    <v-list-item-title>Guardian Name</v-list-item-title>
                    <v-list-item-subtitle>{{ guardianName }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>
                    <v-list-item-title>Company</v-list-item-title>
                    <v-list-item-subtitle> {{company}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line @click="">
                <v-list-item-content>
                    <v-list-item-title>Date of birth</v-list-item-title>
                    <v-list-item-subtitle>{{dob | formatDate}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>
                    <v-list-item-title>Created Date</v-list-item-title>
                    <v-list-item-subtitle> {{ createdDate | formatDate}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>
            <v-subheader>
                <v-icon color="indigo"
                        left>
                    mdi-map-marker
                </v-icon>
                Address
            </v-subheader>
            <v-list-item @click="">
                <v-list-item-content>
                    <v-list-item-title>{{ `${address.addrs} ${address.apt}` }}</v-list-item-title>
                    <v-list-item-subtitle>
                        {{ `${address.city}, ${address.state}, ${address.zip_code}` }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-card >
</template>

<script>
    import {TOKEN} from "@/shared/enums/TokenSeparator";

    export default {
        name: "UserInfoDisplay",
        props:["setName", "setEmail", "setPhone", "setType", "setStatus", "setUserType", "setUserNumber"
        , "setUsername", "setCompany", "setDOB", "setCreatedDate", "setAddress", "setGuardianName"],
        data() {
            return {
                address: {}
            }
        },
        computed:{
            name(){
                return this.setName;
            },
            email(){
                return this.setEmail;
            },
            phone(){
                return this.setPhone;
            },
            type(){
                return this.setType;
            },
            status(){
                return this.setStatus;
            },
            userType(){
                return this.setUserType;
            },
            userNumber(){
                return this.setUserNumber;
            },
            username(){
                return this.setUsername;
            },
            company(){
                return this.setCompany;
            },
            dob(){
                return this.setDOB;
            },
            createdDate(){
                return this.setCreatedDate;
            },
            guardianName(){
                return this.setGuardianName;
            }
        },
        watch:{
            setAddress: {
                handler: function (value) {

                    if(typeof value === 'string' || value instanceof String)
                        value = JSON.parse(value);

                    this.address = {
                        addrs: value && value.address_line_1 ? value.address_line_1 : '',
                        apt: value && value.address_line_2 ? value.address_line_2 : '',
                        city: value && value.city ? value.city : '',
                        country: value && value.country ? value.country : '',
                        state: value && value.state ? value.state : '',
                        zip_code: value && value.zip_code ? value.zip_code : ''
                    };
                },
                immediate: true
            }
        }

    }
</script>

<style scoped>

</style>